<div class="msg-table-wrapper">
  @if (usersRelated.length) {
    <ng-scrollbar class="std-scrollbar" appearance="native" orientation="vertical">
      @for (user of usersRelated; track user.user_id) {
        <span (click)="optionSelected({ action: 'select', user: user })" class="msg-table-row p-1">
          <span [ngClass]="{ 'font-bold': user?.is_admin }" class="text-navy-700 font-semibold text-sm cursor-pointer">
            {{ user.name }}
          </span>
          <span class="text-navy-600 font-normal text-sm cursor-pointer">
            {{ user.company_name }}
          </span>
          <span class="text-navy-500 font-normal italic text-xs cursor-pointer">{{
            user.is_team_member ? 'Team Member' : ''
          }}</span>
          @if (
            isSelected(user) &&
            (isUserAdmin() ||
              isAddedByCurrentUser(user) ||
              (selectedView$ | async) === MESSAGING_VIEWS.DISCUSSION_CREATE) &&
            !isSelfUser(user)
          ) {
            <span
              (click)="optionSelected({ action: 'remove', user: user }); $event.stopPropagation()"
              class="text-blue-700 text-sm font-semibold text-center cursor-pointer"
            >
              remove
            </span>
          }
        </span>
      }
    </ng-scrollbar>
  }
  @if (!usersRelated.length) {
    <span class="text-navy-600 font-normal text-sm"> No users found </span>
  }
</div>
